import { useRef } from "react";
import { CSSTransition } from "react-transition-group";
import styles from "./Checkbox.module.scss";
import CheckmarkIcon from "./checkmark.svg?react";
import PartialIcon from "./partial.svg?react";
import cn from "classnames";

interface CheckboxProps {
  checked: boolean | "partial";
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  title?: React.ReactNode;
  error?: boolean;
  className?: string;
}

const Checkbox = ({ checked, onChange, disabled, title, error, className }: CheckboxProps) => {
  const checkRef = useRef(null);
  const partialRef = useRef(null);

  const handleChange = () => {
    if (!disabled) onChange(!checked);
  }

  return (
    <div className={cn(
      styles.root,
      checked === true && styles.checked,
      checked === "partial" && styles.partial,
      error && styles.error,
      disabled && styles.disabled,
      className && className,
    )}>
      <label className={styles.label}>
        <input
          type="checkbox"
          checked={Boolean(checked)}
          onChange={handleChange}
        />
        <div className={styles.checkbox}>
          <CSSTransition
            nodeRef={checkRef}
            in={(checked === true)}
            out="true"
            timeout={500}
            classNames={{
              enter: styles.checkboxIconEnter,
              enterActive: styles.checkboxIconEnterActive,
              exit: styles.checkboxIconExit,
              exitActive: styles.checkboxIconExitActive,
              exitDone: styles.checkboxIconExitDone,
            }}
            mountOnEnter
          >
            <div ref={checkRef} className={styles.checkboxIcon}>
              <CheckmarkIcon />
            </div>
          </CSSTransition>
          <CSSTransition
            nodeRef={partialRef}
            in={(checked === "partial")}
            timeout={500}
            classNames={{
              enter: styles.checkboxIconEnter,
              enterActive: styles.checkboxIconEnterActive,
              exit: styles.checkboxIconExit,
              exitActive: styles.checkboxIconExitActive,
              exitDone: styles.checkboxIconExitDone,
            }}
            mountOnEnter
          >
            <div ref={partialRef} className={styles.checkboxIcon}>
              <PartialIcon />
            </div>
          </CSSTransition>
        </div>
        {title ? (<span className={styles.title}>{title}</span>) : null}
      </label>
    </div>
  );
};

export default Checkbox;
